var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":[
    { name: 'Default', value: 0 },
    { name: 'Json', value: 1 },
    { name: 'Hex', value: 2 },
    { name: 'Base64', value: 3 },
  ],"item-text":"name","item-value":"value","label":_vm.$t('mqtt.meta.fields.parsingTopic')},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }